import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var IInvoice;
(function (IInvoice) {
  var State;
  (function (State) {
    /**
     * The brand order is not shipped yet and can not be paid.
     * buf:lint:ignore ENUM_FIRST_VALUE_ZERO
     */
    State["NOT_PAYABLE"] = "NOT_PAYABLE";
    /**
     * The brand order has shipped and can be paid.
     */
    State["UNPAID"] = "UNPAID";
    /**
     * The brand order should be paid but it is not.
     */
    State["OVERDUE"] = "OVERDUE";
    /**
     * The brand order is paid either by regular payment or payment/installment plan.
     */
    State["PAID"] = "PAID";
  })(State = IInvoice.State || (IInvoice.State = {}));
  var PaymentPlanEligibility;
  (function (PaymentPlanEligibility) {
    /**
     * The invoice has no eligible payment plan.
     * buf:lint:ignore ENUM_FIRST_VALUE_ZERO
     */
    PaymentPlanEligibility["NONE"] = "NONE";
    /**
     * The invoice can be enrolled into overdue payment plan.
     */
    PaymentPlanEligibility["OVERDUE_ELIGIBLE"] = "OVERDUE_ELIGIBLE";
    /**
     * The invoice can be enrolled into launch with faire payment plan.
     */
    PaymentPlanEligibility["LAUNCH_WITH_FAIRE_ELIGIBLE"] = "LAUNCH_WITH_FAIRE_ELIGIBLE";
  })(PaymentPlanEligibility = IInvoice.PaymentPlanEligibility || (IInvoice.PaymentPlanEligibility = {}));
  var PaymentStatusTextType;
  (function (PaymentStatusTextType) {
    /**
     * buf:lint:ignore ENUM_FIRST_VALUE_ZERO
     */
    PaymentStatusTextType["ALARM"] = "ALARM";
    PaymentStatusTextType["NORMAL"] = "NORMAL";
  })(PaymentStatusTextType = IInvoice.PaymentStatusTextType || (IInvoice.PaymentStatusTextType = {}));
  var IPaymentStatusData;
  (function (IPaymentStatusData) {
    /**
     * Return an instance of IPaymentStatusData with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IPaymentStatusData.build = function (partial) {
      return _objectSpread({}, partial !== null && partial !== void 0 ? partial : {});
    };
  })(IPaymentStatusData = IInvoice.IPaymentStatusData || (IInvoice.IPaymentStatusData = {}));
  /**
   * Return an instance of IInvoice with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  IInvoice.build = function (partial) {
    return _objectSpread({}, partial !== null && partial !== void 0 ? partial : {});
  };
})(IInvoice || (IInvoice = {}));